import { useAtomValue } from 'jotai';
import { productsManagementFiltersAtom } from 'atoms/filters/products-management-filters.ts';
import { useHasActiveProductsManagementFilters } from '@/activityLog/productsManagement/Filters/hooks/useHasActiveProductsManagmentFilters.ts';

export const useIsProductsManagementFiltered = () => {
  const filters = useAtomValue(productsManagementFiltersAtom);

  return useHasActiveProductsManagementFilters(filters);
};
